import { FetchError } from "@/@types/fetch";
import { ZodError } from "zod";

export default function getErrorMessage(error: any) {
  if (error instanceof ZodError) {
    return {
      error: error.formErrors.fieldErrors,
    };
  }
  if (error instanceof Error || 
    error instanceof FetchError
  ) {
    return {
      error: error.message,
    };
  }
  
  return {
    error: String(error),
  };
}
